import React from "react";
import { Spinner } from "react-bootstrap";
import { OrbitProgress } from "react-loading-indicators";

const Loading = ({ title, style }) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.75)',
            position: 'absolute',
            width: '100%',
            top: 0
        }}>
            {/* <div>{title}</div> */}
            <OrbitProgress variant="track-disc" color="#3BCFCE" size="small" text="" textColor="" />
        </div>
    )
}

export default Loading